export default "__VITE_ASSET__thZnhp$4__"